import { SxProps, Theme } from "@mui/material";

export const settingBoxStyles: SxProps<Theme> = {
  mb: 3,
};

export const headerTextStyles: SxProps<Theme> = (theme) => ({
  mb: 1,
  color: theme.palette.modalColors.colorLable,
});

export const textFieldStyles: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#06B6D4",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#06B6D450",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#06B6D4",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#06B6D4",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#06B6D4",
  },
};

export const formControlStyles: SxProps<Theme> = {
  mb: 1,
};

export const selectStyles: SxProps<Theme> = {
  borderRadius: "8px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#06B6D4",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#06B6D450",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#06B6D4",
  },
};

export const inputLabelStyles: SxProps<Theme> = {
  color: "#06B6D4",
};

export const menuItemStyles: SxProps<Theme> = {
  fontSize: "14px",
  wordBreak: "break-word",
};
